module.exports = __webpack_public_path__ + "img/2.c69f68a1.jpg";